import React from "react";
import MilesPointsDashboard from "../../components/gettingStarted/milesPoints/MilesPointsDashboard";

function MilesPointsPointsSection() {
  const stats = [
    {
      label: "Available Points",
      amount: "1,294",
    },
    {
      label: "Points Used",
      amount: "1,294",
    },
    {
      label: "Upcoming Expirations",
      amount: "1,294",
    },
    {
      label: "Total Points Earned",
      amount: "1,294",
    },
  ];
  return (
    <div className="flex flex-col">
      <div className="flex gap-4 ">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="flex flex-1 h-28 rounded-xl bg-white flex-col border border-black/10 p-4 justify-center"
          >
            <span>{stat.label}</span>
            <span className="text-lg">{stat.amount}</span>
          </div>
        ))}
      </div>
      <MilesPointsDashboard />
    </div>
  );
}

export default MilesPointsPointsSection;
